import { Formatters, Messages } from '../../codegen/Localize';
import { simpleActionErrorMsg, simpleActionSuccessMsg } from '../../commonInfra/contentActions/ActionHelpers';
import { ContentActionNotification } from '../../commonInfra/contentActions/ContentActionNotification';
import { openReactConfirmationDialog } from '../../commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { L10n } from '../../ts/L10n/L10n';
import { RunFlowTaskInfo } from '../../ts/models/RunFlowTaskInfo';
import { Set } from '../../ts/models/Set';
import { RunFlowTasks } from '../resources/RunFlowTasks';

export namespace RunFlowTasksAction {
  function runFlowOnOutputSteps(runFlowTaskInfos: Set<RunFlowTaskInfo>) {
    return RunFlowTasks.run(runFlowTaskInfos.keys());
  }

  export function dialog(runFlowTaskInfos: Set<RunFlowTaskInfo>) {
    const taskCount = runFlowTaskInfos.size();
    let dialogBody;
    if (taskCount === 1) {
      const task = runFlowTaskInfos.first();
      dialogBody = Messages.runFlowTaskRunPrompt({
        FLOW_NAME: L10n.elideIfLong(task.flow.name)
      });
    } else {
     dialogBody = Messages.runFlowTasksRunPrompt({
        ITEM_COUNT_LOC: Formatters.formatCount(taskCount)
      });
    }

    const dialogInstance = openReactConfirmationDialog<Set<RunFlowTaskInfo>, IResult>({
      title: Messages.runNow(),
      message: dialogBody,
      dialogWidth: TabDialogWidth.width375px,
      paramsForAction: runFlowTaskInfos,
      actionName: Messages.runNowConfirmButton(),
      action: runFlowOnOutputSteps
    });

    dialogInstance.result.then((result: IResult) => {
      ContentActionNotification.displaySingleToastForResult({
        items: runFlowTaskInfos,
        errors: result.errors,
        successMsg: simpleActionSuccessMsg(Messages.runFlowTasksRunSuccess),
        errorMsg: simpleActionErrorMsg(Messages.runFlowTasksRunError),
      });
    });

    return Promise.resolve(dialogInstance.result);
  }
}
